import { TableProps } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useTableSearchParams } from "./UseTableSearchParams";
import { selectQueryFromParams } from "../utils/ConvertQueryParams";
import { Filter } from "../types/utils/Filter";
import { useLazyGetPartnersQuery } from "../store/api/PartnerApi";
import { PartnerDTO } from "../types/partner/PartnerDTO";
import { useEffect } from "react";

type UseGetPartnersType = () => {
  partners: any;
  onChangeTable: TableProps<PartnerDTO>["onChange"];
  loading: boolean;
  filter: Filter;
  total: number | undefined;
};

export const useGetPartners: UseGetPartnersType = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { filter } = useTableSearchParams();

  const params = new URLSearchParams();

  params.append("page", filter.page.toString());
  params.append("size", filter.size.toString());

  if (filter.partner_name) params.append("partner_name", filter.partner_name);
  if (filter.coupon_name) params.append("coupon_name", filter.coupon_name);
  if (filter.category_ids && filter.category_ids.length > 0) {
    params.append("category_ids", filter.category_ids.join(","));
  }
  if (filter.city_ids && filter.city_ids.length > 0) {
    params.append("city_ids", filter.city_ids.join(","));
  }
  if (filter.employee_ids && filter.employee_ids.length > 0) {
    params.append("employee_ids", filter.employee_ids.join(","));
  }

  const [getPartners, { data, isFetching }] = useLazyGetPartnersQuery();

  const paramsString = params.toString();
  useEffect(() => {
    getPartners({ params: paramsString });
  }, [getPartners, paramsString]);

  const onChangeTable: TableProps<PartnerDTO>["onChange"] = (
    pagination,
    filters
  ) => {
    const typedFilters = filters as {
      coupon?: string[];
      name?: string[];
      category?: string[];
      address?: string[];
      created_by?: string[];
    };

    const toNumberArray = (arr?: string[]) =>
      arr && arr.length > 0
        ? arr.map((x) => Number(x)).filter((x) => !isNaN(x))
        : [];

    const newSearch = selectQueryFromParams(
      {
        pageSize: pagination.pageSize,
        current: pagination.current,
      },
      {
        coupon_name: typedFilters.coupon ? typedFilters.coupon[0] : "",
        partner_name: typedFilters.name ? typedFilters.name[0] : "",
        category_ids: toNumberArray(typedFilters.category),
        city_ids: typedFilters.address ?? [],
        employee_ids: toNumberArray(typedFilters.created_by),
      },
      location.search
    );

    navigate({ search: newSearch }, { replace: true });
  };

  return {
    partners: data?.data?.content,
    onChangeTable,
    loading: isFetching,
    filter,
    total: data?.data?.total_elements,
  };
};
